import React from "react";
import { Link } from "react-router-dom";

// Local Libraries
import phrasebookLoad from "../../../../i18n";
import { Form } from "../../../../components/SkyFramework/Forms";
import { serviceNumberTypeInfoDetails } from '../../ServiceNumberType/serviceNumberTypeForm';
import { summaryOrderDetails, summaryRequirements, summaryNumberFeature, summaryCharges, summaryStatus, summaryButtons } from '../orderInput';

var currencies = [{ value: 'USD', label: 'USD' }, { value: 'EUR', label: 'EUR' }, { value: 'GBP', label: 'GBP' }, { value: 'HKD', label: 'HKD' }, { value: 'CNY', label: 'CNY' }, { value: 'SGD', label: 'SGD' }];

// Constants
const phrasebook = phrasebookLoad();

function changeTariff(selectedTypeNumber, actualState, handleChange, accountLogged) {
  if ([100, 110, 120].includes(accountLogged)) {
    var inputs = []
    if (actualState.add_custom) {
      inputs.push({ label: phrasebook.orders.custom_pricing, type: "section" }, { label: phrasebook.references.currency, type: "select", id: "custom_currency", name: "currency", options: currencies, selected: actualState.custom_tariff.currency, tooltip: phrasebook.tooltip.currency }, [{ label: phrasebook.pricing.nrc, type: "text", placeholder: actualState.custom_tariff.nrc, id: "custom_nrc", name: "nrc", value: actualState.custom_tariff.nrc, tooltip: phrasebook.tooltip.nrc },
      { label: phrasebook.pricing.mrc, type: "text", placeholder: actualState.custom_tariff.nrc, id: "custom_mrc", name: "mrc", value: actualState.custom_tariff.mrc, tooltip: phrasebook.tooltip.mrc }])
      if (selectedTypeNumber.service_type === 'ITFS' || selectedTypeNumber.service_type === 'UIFN') {

        let index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.id === "custom_mrc"));

        inputs.splice((index + 1), 0, { label: phrasebook.pricing.per_minute_rate, type: "subsection" });
        inputs.splice((index + 2), 0, [{ label: phrasebook.pricing.fix_usage_rate, type: "text", placeholder: actualState.custom_tariff.fix_usage_rate, id: "custom_fix_usage_rate", name: "fix_usage_rate", value: actualState.custom_tariff.fix_usage_rate }, { label: phrasebook.pricing.mobile_usage_rate, type: "text", placeholder: actualState.custom_tariff.mobile_usage_rate, id: "custom_mobile_usage_rate", name: "mobile_usage_rate", value: actualState.custom_tariff.mobile_usage_rate }, { label: phrasebook.pricing.payphone_usage_rate, type: "text", placeholder: actualState.custom_tariff.payphone_usage_rate, id: "custom_payphone_usage_rate", name: "payphone_usage_rate", value: actualState.custom_tariff.payphone_usage_rate }])
      }

      if (selectedTypeNumber.service_type === 'SIP Trunking') {
        var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.id === "custom_mrc"));

        inputs.splice((index + 1), 0, { label: phrasebook.pricing.per_channel_charges, type: "subsection" });
        inputs.splice((index + 2), 0,
          [{ label: phrasebook.pricing.nrc_channel_charges, type: "text", placeholder: actualState.custom_tariff.nrc_channel_charges, id: "custom_nrc_channel_charges", name: "nrc_channel_charges", value: actualState.custom_tariff.nrc_channel_charges, tooltip: phrasebook.tooltip.nrc_channel_charges }, { label: phrasebook.pricing.mrc_channel_charges, type: "text", placeholder: actualState.custom_tariff.mrc_channel_charges, id: "custom_mrc_channel_charges", name: "mrc_channel_charges", value: actualState.custom_tariff.mrc_channel_charges, tooltip: phrasebook.tooltip.mrc_channel_charges }]);


        inputs.splice((index + 3), 0, { label: phrasebook.pricing.outbound_charges, type: "subsection" });
        inputs.splice((index + 4), 0, [{ label: phrasebook.pricing.outbound_charges_fixed, type: "text", placeholder: actualState.outbound_charges_fixed, id: "custom_outbound_charges_fixed", name: "outbound_charges_fixed", value: actualState.custom_tariff.outbound_charges_fixed, tooltip: phrasebook.tooltip.outbound_charges_fixed }, { label: phrasebook.pricing.outbound_charges_mobile, type: "text", placeholder: actualState.custom_tariff.outbound_charges_mobile, id: "outbound_charges_mobile", name: "custom_outbound_charges_mobile", value: actualState.custom_tariff.outbound_charges_mobile, tooltip: phrasebook.tooltip.outbound_charges_mobile }, { label: phrasebook.pricing.outbound_charges_special, type: "text", placeholder: actualState.custom_tariff.outbound_charges_special, id: "custom_outbound_charges_special", name: "outbound_charges_special", value: actualState.custom_tariff.outbound_charges_special, tooltip: phrasebook.tooltip.outbound_charges_special }]);

      }
      if (['SIP Trunking', 'DID'].includes(selectedTypeNumber.service_type)) {
        var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.id === "custom_mrc"));
        inputs.splice((index + 1), 0, { label: phrasebook.pricing.inbound_charges_per_minute, type: "subsection" });
        inputs.splice((index + 2), 0, { label: phrasebook.pricing.inbound_charges, type: "text", placeholder: actualState.custom_tariff.inbound_charges, id: "custom_inbound_charges", name: "inbound_charges", value: actualState.custom_tariff.inbound_charges },);
      }
    }
    return (<Form
      handleSubmit={undefined}
      onChange={handleChange}
      inputs={inputs}
    />
    );
  } else return null;

}


export default class SubmitOrder extends React.Component {

  render() {
    const { actualState, handleSubmit, handleChange, prevStep, loggedAccount, selectedTypeNumber, saveChanges } = this.props;
    return (
      <>
        <form class="box p-1 p-sm-2 p-lg-3">
          <div class="container-xs p-0">
            <h2 class="box-title pb-1 mb-1">{phrasebook.orders.submit_order}</h2>

            <div class="section-block mt-2">
              <div class="d-flex mb-2">
                <h3 class="mb-0 mr-h">{phrasebook.orders.order_details}</h3>
              </div>
              {summaryOrderDetails(phrasebook, actualState)}
            </div>
            <hr class="dotted my-3" />

            {serviceNumberTypeInfoDetails(phrasebook, actualState.selectedTypeNumber)}
            <hr class="dotted my-3" />
            {summaryRequirements(phrasebook, actualState)}

            <hr class="dotted my-3" />
            {loggedAccount < 200 && ['requested', 'saved', 'ready', 'confirmed'].includes(actualState.status) ? <label class="custom-checkbox">
              <input type="checkbox"
                id={'add_custom'}
                name={'add_custom'}
                value={actualState.add_custom}
                checked={actualState.add_custom}
                onChange={handleChange}
              />
              <span><strong>{phrasebook.orders.add_custom_pricing} </strong></span>
            </label> : null}
            {actualState.add_custom ? changeTariff(selectedTypeNumber, actualState, handleChange, loggedAccount) : summaryCharges(actualState)}

            {summaryStatus(actualState, loggedAccount, handleChange)}

          </div>
        </form>
        <div class="box p-1 p-sm-2 p-lg-3">
          <div class="d-flex mb-2">
            <h3 class="mb-0 mr-h">{phrasebook.orders.terms_and_conditions_title}</h3>
          </div>
          <div class="alert alert-warning">
            <p>{`i.Global Inbound Services are provided by PCCW Global. The use of which is subject to the General Conditions and any applicable Special Conditions, or other terms and conditions agreed by the Parties.`}</p>
            <p>{`ii.For SIP Trunking services, orders for channels are subject to a minimum of 10 channels for each new connection and a minimum of 5 channels for subsequent additions.`}</p>
            <p>{`iii.For SIP Trunking services, the channel to service number ratio shall not exceed 1:10. If exceeding this ratio, additional channels shall be ordered.`}</p>
            <p>{`iv.Each of the service numbers and channels are subject to a Minimum Contract Period of twelve (12) months after the relevant Service Commencement Date, unless otherwise agreed by the Customer and PCCW Global.`}</p>
            <p>{`v.Upon expiration of the Minimum Contract Period, the service term shall automatically renew on a month-to-month basis unless and until terminated by thirty (30) day prior written termination notice by either Party.`}</p>
            <p>{`vi.PCCW Global may amend or modify the Usage Charges upon not less than seven (7) day prior written notice to the Customer.`}</p>
          </div>
        </div>
        {summaryButtons(actualState, loggedAccount, handleSubmit, prevStep, saveChanges)}
      </>
    );
  }
}
